import React from 'react';
import { CheckCircle, Folder, Tv } from 'lucide-react';

export const MACRO_FOLDER_ICONS: Record<string, React.ReactNode> = {
  'macro-ctv': <CheckCircle size={12} />,
  ctv: <Tv size={12} />
};

export const getMacroFolderIcon = (sk: string): React.ReactNode => {
  return MACRO_FOLDER_ICONS[sk] || <Folder size={12} />;
};
